import React from 'react'
import Table from 'react-bootstrap/Table';
import '../App.css'
function Timing() {
  return (
    <div>
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>Day</th>
          <th>Opening Time</th>
          <th>Closing Time</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Monday</td>
          <td>8:00 AM</td>
          <td>9:30 PM</td>
        </tr>
        <tr>
          <td>Tuesday</td>
          <td>8:00 AM</td>
          <td>9:30 PM</td>
        </tr>
        <tr>
          <td>Wednesday</td>
          <td>8:00 AM</td>
          <td>9:30 PM</td>
        </tr>
        <tr>
          <td>Thursday</td>
          <td>8:00 AM</td>
          <td>9:30 PM</td>
        </tr>
        <tr>
          <td>Friday</td>
          <td>8:00 AM</td>
          <td>9:30 PM</td>
        </tr>
        <tr>
          <td>Saturday</td>
          <td>8:30 AM</td>
          <td>10:00 PM</td>
        </tr>
        <tr>
          <td>Sunday</td>
          <td>11:00 AM</td>
          <td>10:30 PM</td>
        </tr>
      </tbody>
    </Table>
    <div >
        <p className='timchange'><span style={{fontWeight:'600',color:'black',fontSize:'large'}}>*</span> timing may change on special days</p>
    </div>
    </div>
  )
}

export default Timing